import { render } from "./Section5MobileFirst.vue?vue&type=template&id=1cd16914&scoped=true"
const script = {}

import "./Section5MobileFirst.vue?vue&type=style&index=0&id=1cd16914&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cd16914"]])

export default __exports__